<template>
  <div class="centerx con-exemple-prompt p-c-d-dialog">
    <vs-prompt
      @cancel="close()"
      :active.sync="active"
      @close="close()"
      class="order-pay-dialog"
      title="微信支付"
    >
      <div class="con-exemple-prompt overflow-y-auto">
        <div class="order-info">
          <p>订单号：{{ orderInfo.order_id }}</p>
          <p>
            商品名称：
            <span :key="index" v-for="(goods, index) in orderInfo.items">
              <span v-if="index > 0">、</span>
              {{ goods.name }}
            </span>
          </p>
          <p>商品数量：{{ orderInfo.total_count }}</p>
          <p>交易金额：{{ orderInfo.total_price }}</p>
        </div>
        <div class="order-info-qrcode" ref="qrCodeUrl"></div>
        <div class="order-qrcode-text">
          <p>请使用微信 扫一扫</p>
          <p>二维码完成支付</p>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import orderRepo from '@/repo/order'
export default {
  name: 'import-config-dialog',
  data() {
    return {
      active: false,
      orderInfo: '',
    }
  },

  mounted() {},

  methods: {
    open: function (item) {
      this.createPayQRCode(item.order_id)
      this.orderInfo = item
      this.active = true
    },
    waitTime: function (time_duration) {
      return new Promise((resolve) => {
        let a = setTimeout(() => {
          resolve('end')
          clearTimeout(a)
        }, time_duration)
      })
    },
    createPayQRCode: function (order_id) {
      let params = {
        orderNo: order_id,
      }
      let that = this
      orderRepo.orderMobaoPay(params, (error, resp) => {
        if (resp.code === 0 && resp.data.codeUrl) {
          that.creatQrCode(resp.data.codeUrl)
        } else {
          that.$vs.notify({
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },

    async creatQrCode(codeUrl) {
      if (this.$refs.qrCodeUrl) {
        new QRCode(this.$refs.qrCodeUrl, {
          text: codeUrl, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          correctLevel: QRCode.CorrectLevel.L, //由低到高 .L M Q H
        })
        // 定时器每隔一秒查询订单状态
        this.clearTimeSet = setInterval(() => {
          this.getPayStatus()
        }, 1000)
      } else {
        await this.waitTime(100)
        this.creatQrCode(codeUrl)
      }
    },

    getPayStatus() {
      console.log('正在查询')
      let that = this
      let params = {
        orderNo: this.orderInfo.order_id,
      }
      orderRepo.orderStatusQuery(params, (error, resp) => {
        if (resp.code === 0 && resp.data.status) {
          //订单状态：00-成功 01-待支付 02-失败 08-关闭 09-处理中
          if (resp.data.status == '00') {
            that.openNotify('支付成功!', 'success')
            that.close() // 关闭支付弹窗
            that.$emit('@getOrderList') //刷新列表页面
          }
        }
      })
    },

    close: function () {
      clearInterval(this.clearTimeSet) // 关闭弹窗就清除定时器
      this.active = false
    },

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'top-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
    },
  },
}
</script>

<style lang="scss">
// .order-pay-dialog .con-vs-dialog .vs-dialog{
//     max-width: 100% !important;
// }

.order-pay-dialog .vs-dialog {
  width: 500px;
}

.order-pay-dialog .vs-dialog .vs-dialog-header {
  background-color: #fff;
}

.order-pay-dialog .vs-dialog .vs-dialog-header .con-title-after .dialog-title {
  text-align: center;
  padding-left: 34px;
  color: #5e5873;
  font-weight: 500;
  font-size: 24px;
  padding-top: 20px;
}

.order-pay-dialog .vs-dialog .vs-dialog-header .vs-dialog-cancel {
  top: -15px;
}

.order-pay-dialog .vs-dialog footer {
  display: none;
}

.order-pay-dialog .vs-dialog .vs-dialog-text .order-info {
  width: 70%;
  margin: 0 auto;
}

.order-pay-dialog .vs-dialog .vs-dialog-text .order-info-qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-top: 30px;
}

.order-pay-dialog .vs-dialog .vs-dialog-text .order-qrcode-text {
  padding-top: 50px;
  padding-bottom: 10px;
}

.order-pay-dialog .vs-dialog .vs-dialog-text .order-qrcode-text p {
  font-size: 12px;
  text-align: center;
}
</style>
